import CryptoJS from 'crypto-js';
import { AuthService } from 'src/app/services/auth.service';

import { Injectable } from '@angular/core';
import { StorageService } from '@core/services';

export interface PaymentInfo {
  fullName: string;
  creditCard: string;
  expirationDate: string;
  phone: string;
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

@Injectable()
export class CreditCardService {
  private secureKey = '17749937251153819552391078335260'; // Any string, the length should be 32

  constructor(private storage: StorageService, private auth: AuthService) {}

  async savePaymenteInfo(paymentInfo: PaymentInfo): Promise<void> {
    const user = await this.auth.getUser();
    const paymentInfoEncrypted = CryptoJS.AES.encrypt(JSON.stringify(paymentInfo), this.secureKey).toString();
    this.storage.set('pInfo-' + user?.id, paymentInfoEncrypted);
  }

  async getPaymentInfo(): Promise<PaymentInfo | null> {
    const user = await this.auth.getUser();
    const paymentInfoEncrypted = await this.storage.get<string>('pInfo-' + user?.id);
    if (paymentInfoEncrypted) {
      const paymentInfoDecrypted = CryptoJS.AES.decrypt(paymentInfoEncrypted, this.secureKey).toString(
        CryptoJS.enc.Utf8
      );
      return JSON.parse(paymentInfoDecrypted);
    }
    return null;
  }

  async removePaymentInfo(): Promise<void> {
    const user = await this.auth.getUser();
    this.storage.remove('pInfo-' + user?.id);
  }
}
